import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';


@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @ViewChild('prevoiusButton') prevButton;
  @ViewChild('nextButton') nextButton;
  p = 1;
  totalPages: number;
  pa: HTMLElement;
  @Output() pageChange = new EventEmitter<number>();
  displayQuestionList = false;
  @Input() model: Array<any>;

  ngOnInit() {

  }
  onPageChange($event) {
    if ($event) {
      this.pageChange.next($event);
    }
  }
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/pagination/pagination.component.ts